import { ForwardedRef, useEffect, useRef } from "react";

/* eslint-disable */
const useForwardRef = <T>(
    ref: ForwardedRef<HTMLDivElement>,
    initialValue: any = null
) => {
    const targetRef = useRef<T>(initialValue);

    useEffect(() => {
        if (!ref) return;

        if (typeof ref === "function") {
            // @ts-ignore
            ref(targetRef.current);
        } else {
            // @ts-ignore
            ref.current = targetRef.current;
        }
    }, [ref]);

    return targetRef;
};

export default useForwardRef;
